import { defineMessage } from 'services/localization';

export const messages = {
    pageMyDecisionRequiredTitleText: defineMessage('requires_my_approval'),
    pageMyReviewRequiredTitleText: defineMessage('review_required'),
    pageMyOcrRequestsTitleText: defineMessage('captured_by_me'),
    pageTitleRequestsOnReview: defineMessage('requests_on_review_companyname'),
    pageMyOpenTitleText: defineMessage('created_by_me'),
    pageMyReadyToPayTitleText: defineMessage('ready_to_pay'),
    pageMyDraftTitleText: defineMessage('drafts'),
    pageCompanyDecisionRequiredTitleText: defineMessage('decision_required_companyname'),
    pageCompanyReviewRequiredTitleText: defineMessage('review_required_companyname'),
    pageCompanyMyOpenTitleText: defineMessage('my_open_requests_companyname'),
    pageCompanyAllOpenTitleText: defineMessage('open_requests_companyname'),
    pageCompanyAllTitleText: defineMessage('all_requests_companyname'),
    pageTitleRequestsAll: defineMessage('all_requests_companyname'),
    pageTitleRequestsOnApproval: defineMessage('requests_on_approval_companyname'),
    pageTitleRequestsOnHold: defineMessage('requests_on_hold_companyname'),
    pageTitleApprovedRequests: defineMessage('approved_requests_companyname'),
    pageTitleCancelledRequests: defineMessage('cancelled_requests_companyname'),
    pageTitleRejectedRequests: defineMessage('rejected_requests_companyname'),
    pageTitlePaidRequests: defineMessage('paid_requests_companyname'),
    pageTitleBilledRequests: defineMessage('billed_requests_companyname'),
    pageTitleNotBilledRequests: defineMessage('not_billed_requests_companyname'),
    pageTitleAwaitingPaymentRequests: defineMessage('awaiting_payment_requests_companyname'),
    pageTitlePartiallyPaidRequests: defineMessage('partially_paid_requests_companyname'),
    pageTitleFailedRequests: defineMessage('failed_requests_companyname'),
    pageTitleProcessingRequests: defineMessage('processing_requests_companyname'),
    pageTitleGrnNotReceivedRequests: defineMessage('grn_not_received_requests_companyname'),
    pageTitleGrnPartiallyReceivedRequests: defineMessage('grn_partially_received_requests_companyname'),
    pageTitleGrnFullyReceivedRequests: defineMessage('grn_fully_received_requests_companyname'),
    pageTitleAcceptedRequests: defineMessage('accepted_requests_companyname'),
    pageTitleDeclinedRequests: defineMessage('declined_requests_companyname'),
    pageTitleCreditedRequests: defineMessage('credited_requests_companyname'),
    pageTitlePartiallyReceivedRequests: defineMessage('partially_received_requests_companyname'),
    pageTitlePendingBillRequests: defineMessage('pending_bill_requests_companyname'),
    pageTitlePendingReceiptRequests: defineMessage('pending_receipt_requests_companyname'),
    pageTitleClosedRequests: defineMessage('closed_requests_companyname'),
    searchModeTitleText: defineMessage('search_results'),
};
